import { DispatcherInterface } from 'dispatchr';
import BaseStore from 'fluxible/addons/BaseStore';

export type Language = 'en' | 'ja' | 'de' | 'fr' | 'nl' | 'it' | 'es' | 'pt';

interface LanguageStoreState {
    language: Language;
}

export default class LanguageStore extends BaseStore<LanguageStoreState> {
    static storeName = 'LanguageStore';

    private language: Language | null;

    constructor(dispatcher: DispatcherInterface) {
        super(dispatcher);
        this.language = null;
    }

    init(language: Language) {
        this.language = language;
    }

    getLanguage() {
        return this.language;
    }
}
LanguageStore.storeName = 'LanguageStore';



// WEBPACK FOOTER //
// ./src/web/js/contest/stores/language-store.ts